module.exports = __webpack_public_path__ + "static/media/arrow-down-outline.b60cb441.svg";